import { render, staticRenderFns } from "./Toolbar4.vue?vue&type=template&id=4ab5070a&"
import script from "./Toolbar4.vue?vue&type=script&lang=js&"
export * from "./Toolbar4.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar4.vue?vue&type=style&index=0&id=4ab5070a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports